/* eslint-disable import/prefer-default-export */
import { useQuery } from '@tanstack/react-query';
// Services
import { getPostsList } from './postService';
// eslint-disable-next-line no-unused-vars
import * as Types from '../types';

/** @import { BU_ZOL, BU_QWERI , BU_BANZAI } from "../../constants" */
/**
 * @description useQuery Hook to get the posts from a given year.
 * @param {Object} queryParams
 * @param {string} queryParams.year
 * @param {Object} params
 * @param {Number|null} params.excludedEndSlotId
 * @param {Number|null} params.includedStartSlotId
 * @param {string|null} params.resourceId
 * @param {('Pending'|'Accepted'|'Refused')|null} params.status
 * @param {('RemoteWorking'|'Leave')|null} params.type
 * @param {BU_ZOL | BU_QWERI | BU_BANZAI | null} params.businessUnit
 * @param {Object} options useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<{data:Array<Types.Post>}, Error>}
 */
export const usePostsListQuery = (queryParams, params, options) => useQuery({
  queryKey: ['postsList', queryParams, params],
  queryFn: () => getPostsList(queryParams, params),
  ...options,
});
